import React from 'react';
import { Link } from 'react-router-dom';
import Google from '../../assets/images/google.png';
import Smilly from '../../assets/images/smily.png';
import Reviewimg from '../../assets/images/review1.png';
import Reviewimg1 from '../../assets/images/review2..png';
import Reviewimg2 from '../../assets/images/review3..png';

const reviewData = [
    {
        name: 'Amine K.',
        company: 'Étudiant en licence – psychologie',
        stars: 5,
        text: 'Je pensais que j’avais aucune direction. Les mini-jeux de Neoori ont révélé mes forces. J’ai enfin compris dans quoi je suis vraiment bon.',
        avatar: Reviewimg,
    },
    {
        name: 'Sarah L.',
        company: 'Développeuse débutante – reconversion',
        stars: 5,
        text: 'J’ai fait des dizaines de tests d’orientation, mais Neoori est le seul qui m’a donné un plan personnalisé clair. Le coach IA est bluffant.',
        avatar: Reviewimg1,
    },
    {
        name: 'Redouane M.',
        company: 'Jeune diplômé – recherche d’emploi',
        stars: 4,
        text: 'Les recommandations sont ultra précises. J’ai découvert des métiers auxquels j’aurais jamais pensé. Ça te donne confiance.',
        avatar: Reviewimg2,
    },
    {
        name: 'Hanae S.',
        company: 'Créative – 22 ans',
        stars: 5,
        text: 'C’est fun, rapide et personnalisé. Ça change des tests classiques. J’ai adoré l’expérience.',
        avatar: Reviewimg,
    },
];

function Review() {
    return (
        <>
            <section id="reviews" className="review_section row_am">
                <div className="container">
                    <div className="positive_inner">
                        <div className="row">
                            <div className="col-md-6 sticky-top">
                                <div className="sidebar_text"
                                    data-aos="fade-up" data-aos-duration={1500} >
                                    <div className="section_title text-left">
                                        <span className="title_badge">Avis</span>
                                        <h2>
                                            <span>Avis authentiques</span> <br /> de la communauté Neoori
                                        </h2>
                                    </div>
                                    <div className="google_rating">
                                        <div className="star">
                                            {Array.from({ length: 5 }, (_, i) => (
                                                <span key={i}>
                                                    <i className="icofont-star" />
                                                </span>
                                            ))}
                                        </div>
                                        <p>
                                            4,8/5,0 sur{' '}
                                            <img className="img-fluid" src={Google} alt="" />
                                        </p>
                                    </div>
                                    <div className="user_review">
                                        <p>
                                            1399{' '}
                                            <Link to="#">
                                                Avis utilisateurs <i className="icofont-arrow-right" />{' '}
                                            </Link>
                                        </p>
                                    </div>
                                    <div className="smiley_icon">
                                        <img src={Smilly} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="review_side">
                                    {reviewData.map((review, index) => (
                                        <div key={index} className="review_block"
                                            data-aos="fade-up" data-aos-duration={1500} >
                                            <div className="coustomer_info">
                                                <div className="avtar">
                                                    <img src={review.avatar} alt="" />
                                                    <div className="text">
                                                        <h3>{review.name}</h3>
                                                        <span>{review.company}</span>
                                                    </div>
                                                </div>
                                                <div className="star">
                                                    {Array.from({ length: review.stars }, (_, i) => (
                                                        <span key={i}>
                                                            <i className="icofont-star" />
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                            <p>{review.text}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Review;
